import { BaseHubOptions } from "../../BaseHubOptions";
import { ISportStatisticsSubscriptionResponse } from "../../common";

export class SportStatisticsHubOptions extends BaseHubOptions {
	name: string = "sport-stats";
	commonEventNames: string[] = ['ChannelUpdates'];
	messageResolver = (message: ISportStatisticsSubscriptionResponse): object => { return message?.data };
}